import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { ResponsiveService } from '../../services/reponsive.service';
import { AsyncPipe, NgClass } from '@angular/common';
import { NavbarComponent } from "../../components/navbar/navbar.component";

@Component({
  selector: 'app-terms',
  imports: [TranslateModule, AsyncPipe, NgClass, NavbarComponent],
  templateUrl: './terms.component.html',
  styleUrl: '../privacy-policy/terms-and-privacy-policy.component.scss'
})
export class TermsComponent {
  smallScreen$: Observable<boolean> = this.responsiveService.small$;
  mediumScreen$: Observable<boolean> = this.responsiveService.desktop$;
  largeScreen$: Observable<boolean> = this.responsiveService.largeDesktop$;

  constructor(
    private responsiveService: ResponsiveService,
  ) { }
}
